// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oeos-say-bubble{transition:background-color .25s ease;font-family:Noto Sans,sans-serif;border-radius:12px!important}", ""]);
// Exports
module.exports = exports;
